import { useState, useContext, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Header from "../layouts/Header";
import FooterComponent from "../layouts/Footer";
import { ToastContainer, toast } from "react-toastify";
import TokenContext from "../../context/Token/TokenContext";
import claveunica from "../../images/claveunica.svg";
import clienteAxios from "../../Utils/axios";
import Recaptcha from "../../Utils/ReCaptcha"

const { validate, clean, format } = require("../../Utils/ValidateRut");

const LoginComponent = ({ props, history }) => {
  const recaptchaRef = useRef()

  // const token = localStorage.getItem('token');
  // const refresh = localStorage.getItem('refresh');
  // // const token = "";
  // // const refresh = "";

  // useEffect(() => {

  //   window.gtag("event", "inicio", {
  //     event_category: "access",
  //     event_label: "inicio"
  //   });

  //   try {
    
  //   const RefreshToken = async () => {
      
  //       const dataForm = new FormData()
  //       dataForm.append("refresh", refresh)
  
  //       const respuesta = await clienteAxios.post("token/refresh/", dataForm,
  //       {
  //         headers: {
  //           Authorization: "Bearer " + token,
  //           accept: "application/json",
  //         },
  //       });
    
  //       localStorage.setItem("token", respuesta.data.access)
  //       localStorage.setItem("refresh", respuesta.data.refresh)
    
  //       history.push('/formulario/')
      
  //   }
  //       if(token && refresh){
  //         RefreshToken();
  //       }

  //     } catch (error) {
        
  //       localStorage.clear();
  //       history.push('/')
  //     }
  
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const tokenContext = useContext(TokenContext);
  const { Active_Token_F, redirect_login, Redirect_F } = tokenContext;

  const ClickClaveUnica = async () => {
    setLogClave(true);
    const respuesta = await clienteAxios.get("claveunica/url/");

    window.location.href = respuesta.data.url;

    // window.gtag("event", "ingreso_clave_unica", {
    //   event_category: "access",
    //   event_label: "login"
    // });

    setTimeout(() => {
      setLogClave(false);
    }, 5000);
  };

  const [LogClave, setLogClave] = useState(false);
  const [Logueado, setLogueado] = useState(false);

  const [Formulario, setFormulario] = useState({
    rut: "",
    num_serie: "",
  });

  const [BtnIngresar, setBtnIngresar] = useState(true);

  const ValidateRut = (rut) => {
    if (rut !== null && rut !== "") {
      if (validate(clean(rut)) !== true) {
        setFormulario({
          ...Formulario,
          rut: "",
        });

        toast.error("El rut ingresado es inválido.");
        setBtnIngresar(true);
        return;
      } else {
        setFormulario({
          ...Formulario,
          rut: format(rut),
        });
      }
    }
  };

  const ConsultaClaveUnica = async (rut, num_serie) => {
    try {
      // window.gtag("event", "ingreso_nro_serie", {
      //   event_category: "access",
      //   event_label: "login"
      // });

      const dataForm = new FormData();
      dataForm.append("rut", clean(rut.slice(0, -1)));
      dataForm.append("num_serie", num_serie);

      const respuesta = await clienteAxios.post("LoginTipoDoc/", dataForm);

      if (respuesta.status === 200) {
        let rut64 = btoa(format(rut));
        Active_Token_F(rut64);
        localStorage.setItem("code", rut64);
      } else {
        toast.error("El número de serie ingresado es inválido.");
      }
      setLogueado(false);

    } catch (error) {
      toast.error("Por el momento este servicio no está disponible. Prefiera Clave Única")
      setLogueado(false);
    }
  };

  const onChangeForm = (e) => {
    e.preventDefault();

    if (e.target.name === "num_serie" && e.target.value.substring( e.target.value.length-1, e.target.value.length) !== "."){
      setFormulario({
        ...Formulario,
        [e.target.name]: e.target.value,
      })
    }else if (e.target.name === "rut"){
      setFormulario({
        ...Formulario,
        [e.target.name]: e.target.value,
      })
    }  

    if (Formulario.rut.length <= 0 || Formulario.num_serie.length <= 0) {
      setBtnIngresar(true);
    } else {
      setBtnIngresar(false);
    }
  };

  const SubmitData = (e) => {
    e.preventDefault();
    setLogueado(true);
    if (Formulario.rut.trim() === "" || Formulario.num_serie.trim() === "") {
      toast.error("Todos los campos son obligatorios.");
      setBtnIngresar(true);
      return;
    } else {
      ConsultaClaveUnica(Formulario.rut, Formulario.num_serie);
    }
  };


  const [show, setShow] = useState(false);

  const [/*ValidCaptcha*/, setValidCaptcha] = useState({})

  const onChangeRecaptcha = value => {
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      value === "undefined"
    ) {
      setValidCaptcha(false)
    } else {
      setValidCaptcha(true)
    }
  }

  useEffect(() => {
    if (redirect_login) {
      Redirect_F(false);
      history.push("/formulario/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirect_login]);

  const NoPaste = (e) => {
    e.preventDefault();
    return false;
  };

  
  return (
    <div className="body-ss">
      <Header />

      <div className="contenido-ss">
        <ToastContainer closeOnClick={true} pauseOnHover={true} />
        <div className="contenedor">
          <div className="contenedor-login shadow">
            <div className="titulo-login">
              <h1 className="py-2">Ingresa a tu portal en línea</h1>
            </div>

            <form className="form-login" onSubmit={SubmitData}>
              <TextField
                id="outlined-basic"
                onChange={onChangeForm}
                value={Formulario.rut !== "" ? format(Formulario.rut) : ""}
                onBlur={() => ValidateRut(Formulario.rut)}
                name="rut"
                className="my-2 elementos-login-ss mx-auto"
                fullWidth
                label="RUT"
                variant="outlined"
                size="small"
                autoComplete="off"
                onPaste={(e) => NoPaste(e)}
              />

              <TextField
                id="outlined-basic"
                onChange={onChangeForm}
                value={Formulario.num_serie ? Formulario.num_serie : ""}
                name="num_serie"
                className="my-2  elementos-login-ss mx-auto"
                fullWidth
                label="N° Documento / Serie"
                variant="outlined"
                size="small"
                autoComplete="off"
                onPaste={(e) => NoPaste(e)}
              />

              <p
                className="text-center my-2"
                onClick={() => setShow(!show)}
                style={{ fontSize: 12, cursor: "pointer" }}
              >
                ¿Dónde se encuentra el N° Documento / Serie?
              </p>

              <Button
                className="btn-login-ss elementos-login-ss mx-auto text-center my-2"
                disabled={BtnIngresar}
                type="submit"
              >
                INGRESAR{" "}
                {Logueado ? (
                  <div
                    className="spinner-border spinner-border-sm ml-2"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : null}
              </Button>

              <p className="text-center my-2" style={{ fontSize: 12 }}>
                Puedes acceder con tu clave única
              </p>

              <Button
                className="btn-login-ss elementos-login-ss mx-auto my-2"
                onClick={() => ClickClaveUnica()}
                disabled={LogClave}
              >
                <img
                  src={claveunica}
                  alt="Imagen clave unica Superintendencia De Salud"
                />{" "}
                CLAVE ÚNICA
                {LogClave ? (
                  <div
                    className="spinner-border spinner-border-sm ml-2"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : null}
              </Button>

              <div className="mx-auto my-2">
                <a
                  href="https://claveunica.gob.cl/"
                  className="mx-auto"
                  style={{ color: "#0064ac" }}
                >
                  ¿No tienes clave única?
                </a>
              </div>
            </form>
          </div>
        </div>
        <Recaptcha {...{ onChangeRecaptcha, recaptchaRef }} />{" "}
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={() => setShow(false)}
        >
          <Modal.Header>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="d-flex mx-auto"
            >
              Aquí puede encontrar su N° Documento / Serie.
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img
              src="https://servicios.superdesalud.gob.cl/ReclamosApbWeb/img/index/ci-nueva.png"
              className="img-fluid mx-auto d-block"
              alt="Imagen Rut Superintendencia De Salud"
            />

            <img
              src="https://servicios.superdesalud.gob.cl/ReclamosApbWeb/img/index/ci-antiguo.png"
              className="img-fluid mx-auto my-2 d-block"
              alt="Imagen Rut Superintendencia De Salud"
            />
          </Modal.Body>
        </Modal>
      </div>

      <FooterComponent />
    </div>
  );
};

export default LoginComponent;
